const state = {
  overflow_drop_showing: false,
  overflow_item_id: null,
  overflow_options: [],
  overflow_position: { top: 0, left: 0 },
};

const getters = {
  overflow_drop_showing(state) {
    return state.overflow_drop_showing;
  },
  overflow_item_id(state) {
    return state.overflow_item_id;
  },
  overflow_options(state) {
    return state.overflow_options;
  },
  overflow_position(state) {
    return state.overflow_position;
  },
};

const mutations = {
  setOverflowDropShowing(state, payload) {
    state.overflow_drop_showing = payload;
  },
  setOverflowItemId(state, payload) {
    state.overflow_item_id = payload;
  },
  setOverflowOptions(state, payload) {
    state.overflow_options = payload;
  },
  setOverflowDropPosition(state, payload) {
    state.overflow_position = payload;
  },
};

const actions = {
  setOverflowDropShowing(context, payload) {
    context.commit('setOverflowDropShowing', payload);
  },
  setOverflowItemId(context, payload) {
    context.commit('setOverflowItemId', payload);
  },
  setOverflowOptions(context, payload) {
    context.commit('setOverflowOptions', payload);
  },
  setOverflowDropPosition(context, payload) {
    context.commit('setOverflowDropPosition', payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
